/* eslint-disable class-methods-use-this */
import React from 'react';
import LinkifyIt from 'linkify-it';
import tlds from 'tlds';
import { Link } from 'react-router-dom';
import config from '../../../../config';

const linkify = new LinkifyIt();
linkify.tlds(tlds);

class Linkify extends React.Component {
    isUtrDomain(url) {
        const utrDomains = [`app.${config.siteBaseUrl}`, 'localhost:3443'];
        let isUtrDomain = false;
        utrDomains.forEach((domain) => {
            if (url.includes(domain)) {
                isUtrDomain = true;
            }
        });
        return isUtrDomain;
    }

    parseString(string) {
        if (string === '') {
            return string;
        }

        const matches = linkify.match(string);
        if (!matches) {
            return string;
        }

        const elements = [];
        let lastIndex = 0;
        matches.forEach((match, i) => {
            // Push preceding text if there is any
            if (match.index > lastIndex) {
                elements.push(string.substring(lastIndex, match.index));
            }

            if (this.isUtrDomain(match.url)) {
                // eslint-disable-next-line no-useless-escape
                const pathRegex = /(http[s]?:\/\/)?([^\/\s]+)(.*)/;
                const path = match.url.match(pathRegex)[3];
                elements.push(<Link to={path}>{match.text}</Link>);
            } else {
                // eslint-disable-next-line react/no-array-index-key
                const linkProps = {
                    href: match.url,
                    key: `link${i}`,
                };

                if (this.props.openInNewTab) {
                    linkProps.target = '_blank';
                    linkProps.rel = 'noopener noreferrer';
                }

                elements.push(<a {...linkProps}>{match.text}</a>);
            }

            // TODO: clean this method up
            // eslint-disable-next-line
            lastIndex = match.lastIndex;
        });

        // Push remaining text if there is any
        if (string.length > lastIndex) {
            elements.push(string.substring(lastIndex));
        }

        return (elements.length === 1) ? elements[0] : elements;
    }

    parse(children, key) {
        if (typeof children === 'string') {
            return this.parseString(children);
        }

        if (React.isValidElement(children) && (children.type !== 'a') && (children.type !== 'button')) {
            return React.cloneElement(children, { key }, this.parse(children.props.children));
        }

        if (Array.isArray(children)) {
            return children.map((child, i) => this.parse(child, i));
        }

        return children;
    }

    render() {
        return (
            <React.Fragment>
                {this.parse(this.props.children)}
            </React.Fragment>
        );
    }
}

export default Linkify;
